




























import Vue from "vue";
import Component from "vue-class-component";
import PageHeader from "@/components/navigation/page-header.vue";
import { Prop, Watch } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "page",
    components: {
        PageHeader,
    },
})
export default class Page extends Vue {
    @Prop({ default: false })
    loading: boolean;

    @Prop({ default: false })
    noHeader: boolean;

    @Prop({})
    title: string;

    hasMounted: boolean = false;

    mounted() {
        this.hasMounted = true;
    }
}
